import { formatarDataHora } from '@common/i18n/formatosData';
import { Badge, Button } from '@ntconsult/aluma-react';
import { Check, Clock } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { EscritaAxiis, MinhaParticipacao } from '../types/Formulario';
import { ResumoResposta, resumoSalvo } from './ResumoResposta';

/** Linha de gravação no Axiis (spec 05 R12): check `success` ou relógio `warning`, uma por item. */
function LinhasAxiis({ itens }: { itens: EscritaAxiis[] }) {
  const { t } = useTranslation('formulario');
  return (
    <ul className="flex flex-col gap-1 text-sm">
      {itens.map((x) => {
        const ok = x.status === 'sucesso';
        const Icone = ok ? Check : Clock;
        return (
          <li
            key={x.item}
            className={`flex items-start gap-2 ${ok ? 'text-success' : 'text-warning'}`}
          >
            <Icone aria-hidden className="mt-0.5 size-4 shrink-0" />
            {ok
              ? t(x.item === 'camiseta' ? 'axiis.camiseta.sucesso' : 'axiis.endereco.sucesso')
              : t('axiis.pendente')}
          </li>
        );
      })}
    </ul>
  );
}

/** A resposta salva, sem o formulário (spec 33 R16, R17). `onAlterar` só com a campanha aberta. */
export function Respondido({
  participacao,
  onAlterar,
}: {
  participacao: MinhaParticipacao;
  onAlterar?: () => void;
}) {
  const { t } = useTranslation('formulario');
  const r = participacao.resposta;
  if (!r) return null;
  const foto = participacao.dadosApresentados?.enderecoOficial ?? null;
  return (
    <section aria-labelledby="respondido-titulo" className="flex flex-col gap-5">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <Badge tone="success" id="respondido-titulo">
          {t('respondido.selo')}
        </Badge>
        <p className="text-sm text-foreground-muted">
          {t('respondido.quando', { quando: formatarDataHora(r.atualizadaEm) })}
        </p>
        {onAlterar && (
          <Button type="button" variant="secondary" className="sm:ml-auto" onClick={onAlterar}>
            {t('respondido.alterar')}
          </Button>
        )}
      </div>
      <ResumoResposta resumo={resumoSalvo(r, foto)} campanha={participacao.campanha} />
      {participacao.escritasAxiis.length > 0 && <LinhasAxiis itens={participacao.escritasAxiis} />}
    </section>
  );
}
